// © Microsoft Corporation. All rights reserved.

/** Global map for inline script so the initial cookie map is cached. */
let cookieMapInline: {[cookieName: string]: string};

/**
 * Helper to get cookie value at inline script. This were to have minimal dependency.
 * Snapshot of cookies will be made and do not respect cookie changes during runtime.
 * @param name - The cookie name
 * @returns Decoded cookie value when found, otherwise null
 */
export function getCookieInline(name: string): string {
    if (!name) {
        return null;
    }

    if (!cookieMapInline) {
        const cookiePairs = document.cookie.split("; ");
        cookieMapInline = {};

        const length = cookiePairs && cookiePairs.length;
        for (let index = 0; index < length; index++) {
            const cookieKeyValue = cookiePairs[index].split("=");
            cookieMapInline[cookieKeyValue[0].toLocaleLowerCase()] = decodeURIComponent(cookieKeyValue[1]);
        }
    }

    const normalizedName = name.toLocaleLowerCase();
    const cookieVal = cookieMapInline[normalizedName];
    return cookieVal || null;
}

/**
 * Helper to get encoded cookie value at inline script.
 * @param name - The cookie name
 * @returns Encoded cookie value when found, otherwise null
 */
export function getEncodedCookieInline(name: string): string {
    const cookieVal = getCookieInline(name);
    return (cookieVal && encodeURIComponent(cookieVal)) || null;
}

/** Only used for unit test */
export function resetCookieMapInline() {
    cookieMapInline = null;
}
